import TWOA from "./biofit-builder-series-2A.png";
import AJ from "./biofit-builder-series-AJ.png";
import AM from "./biofit-builder-series-AM.png";
import BT from "./biofit-builder-series-BT.png";
import CX from "./biofit-builder-series-CX.png";
import EB from "./biofit-builder-series-EB.png";
import EE from "./biofit-builder-series-EE.png";
import GG from "./biofit-builder-series-GG.png";
import GX from "./biofit-builder-series-GX.png";
import IP from "./biofit-builder-series-IP.png";
import KX from "./biofit-builder-series-KX.png";
import MTCL from "./biofit-builder-series-MTCL.png";
import MTHD from "./biofit-builder-series-MTHD.png";
import MVMT from "./biofit-builder-series-MVMT.png";
import RT from "./biofit-builder-series-RT.png";
import RX from "./biofit-builder-series-RX.png";
import RX_DC from "./biofit-builder-series-RX-DC.png";
import Scepter from "./biofit-builder-series-sceptor.png";
import TX from "./biofit-builder-series-TX.png";
import TXG from "./biofit-builder-series-TXG.png";
import UU from "./biofit-builder-series-UU.png";
import WW from "./biofit-builder-series-WW.png";
import Z from "./biofit-builder-series-Z.png";

export default {
  TWOA,
  AJ,
  AM,
  BT,
  CX,
  EB,
  EE,
  GG,
  GX,
  IP,
  KX,
  MTCL,
  MTHD,
  MVMT,
  RT,
  RX,
  "RX-DC": RX_DC,
  Scepter,
  TX,
  TXG,
  UU,
  WW,
  Z,
};
